import {Params} from '@angular/router';

export function concatQueryParams(url: string, queryParams: Params): string {
  const urlObj = new URL(url);
  Object.entries(queryParams).forEach(([key, value]) => {
    urlObj.searchParams.set(key, value);
  });
  return urlObj.href;
}
